export const cms = (table: string, id: string | null | undefined, column: string): { 'data-mdlfy-cms'?: string } =>
    id ? { 'data-mdlfy-cms': `${table}:${id}:${column}` } : {}
